import React from 'react';

import { SVGComponentProps } from './svg.types';

const ClipboardSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9609 12H12.9598V14C12.9599 14.2626 12.9084 14.5226 12.808 14.7653C12.7076 15.0079 12.5604 15.2284 12.3747 15.4141C12.1891 15.5999 11.9687 15.7472 11.7261 15.8477C11.4835 15.9483 11.2235 16 10.9609 16H2.96094C2.4305 16 1.9218 15.7893 1.54672 15.4142C1.17165 15.0391 0.960938 14.5304 0.960938 14V6C0.960788 5.73731 1.01242 5.47718 1.11287 5.23446C1.21333 4.99174 1.36064 4.7712 1.54639 4.58545C1.73214 4.3997 1.95267 4.25239 2.19539 4.15194C2.43811 4.05148 2.69825 3.99985 2.96094 4H4.9598V2C4.9598 1.73726 5.01156 1.4771 5.11215 1.23437C5.21273 0.991644 5.36015 0.771115 5.54599 0.585383C5.73182 0.399651 5.95244 0.252355 6.19522 0.151913C6.438 0.0514709 6.6982 -0.000149811 6.96094 3.26561e-07H14.9609C15.4914 3.26561e-07 16.0001 0.210714 16.3752 0.585787C16.7502 0.96086 16.9609 1.46957 16.9609 2V10C16.9609 10.2626 16.9092 10.5227 16.8087 10.7654C16.7082 11.008 16.5609 11.2285 16.3752 11.4142C16.1894 11.5999 15.969 11.7472 15.7263 11.8478C15.4837 11.9483 15.2236 12 14.9609 12ZM14.9609 2H6.96094V4H10.9609C11.2235 4 11.4835 4.05174 11.7261 4.15226C11.9687 4.25279 12.1891 4.40012 12.3747 4.58586C12.5604 4.77159 12.7076 4.99208 12.808 5.23472C12.9084 5.47736 12.9599 5.73741 12.9598 6V10H14.9609V2Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default ClipboardSVG;
